document.addEventListener("DOMContentLoaded", () => {
  
  theme.addDelegateEventListener(document, "click", ".rte.collapse-text + .button-row a.read-more", (evt, delEl) => {
    evt.preventDefault();
    delEl.parentNode.previousElementSibling.classList.add('open');
    // hide read more button after the text block has expanded
    setTimeout(() => {
      delEl.classList.add('hidden');
      delEl.nextElementSibling.classList.remove('hidden');
    }, 300);
  });

  theme.addDelegateEventListener(document, "click", ".rte.collapse-text + .button-row a.read-less", (evt, delEl) => {
    evt.preventDefault();
    delEl.parentNode.previousElementSibling.classList.remove('open');
    // show read more button after the text block has expanded
    setTimeout(() => {
      delEl.classList.add('hidden');
      delEl.previousElementSibling.classList.remove('hidden');
    }, 300);
  });
  
});
